<div class="sidebar-button" [class.selected]="selected" [class.collapsed]="collapsed">
  <button mat-flat-button>
    <span class="icon">
      <mat-icon>{{icon}}</mat-icon>
    </span>
    <span class="title" [class.collapsed]="collapsed">{{title | translate}}</span>
  </button>
</div>
